import { LOCALES } from './_constants';

export enum ECountries {
  RU = 'ru',
  EN = 'en',
  ZH = 'zh',
  GE = 'ge',
  TR = 'tr',
}

export type TLocale = (typeof LOCALES)[keyof typeof LOCALES];

export enum EBlocksNames {
  HOW_START = 'howStart',
  LEARN_INFO = 'learnInfo',
  COPYRIGHT_APPEAL = 'copyright_appeal',
  OFFER = 'offer',
  ACCESS_RECOVERY = 'access_recovery',
  PRIVACY_POLICY = 'privacy_policy',
  OUR_PARTNERS = 'our_partners',
  MARKETPLACE = 'marketplace',
}
